export default __webpack_public_path__ + "static/equip_img3-c24473e8c6af15963f04777b3fbd1117.jpg";